import React, { useState } from "react";

import { useAuthDataContext } from "../../components/auth-provider";
import { Add2HSButton } from "../../Add2HS";
import { Box, Container, CssBaseline, Grid, makeStyles, Snackbar } from "@material-ui/core";
import { Copyright } from "./Copyright";
import { SignInForm } from "./SignInForm";
import { SignUpForm } from "./SignUpForm";
import { ForgotPassForm } from "./ForgotPassForm";
import { Alert } from "../../components/MySnackToast";

export const useStyles = makeStyles((theme) => ({
  paper: {
    // marginTop: theme.spacing(8),
    paddingTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export const LoginPage = () => {

  const [modo, setModo] = useState('login');

  const [msgSenhaRedefinida, setMsgSenhaRedefinida] = useState<string | undefined>(undefined);

  const classes = useStyles();

  const { errorMessage, resetErrorMessage } = useAuthDataContext();

  const handleClose = () => resetErrorMessage && resetErrorMessage();

  const handleCloseSenhaRedefinida = () => setMsgSenhaRedefinida(undefined);

  return <div>
    <Add2HSButton />

    <Container component="main" maxWidth="xs">
      <CssBaseline />

      <div className={classes.paper}>

        <img src={'/android-chrome-192x192.png'} alt="APC Mobile" />
        <hr />

        {modo === 'login' && <SignInForm />}
        {modo === 'register' && <SignUpForm />}
        {modo === 'forgot' && <ForgotPassForm onOk={() => {
          setModo('login');
          setMsgSenhaRedefinida('Uma mensagem com um link será enviada para o email informado');
        }} />}

        <Grid container>
          <Grid item xs>
            {modo === 'login' && <a href="#/" onClick={() => setModo('forgot')}>Esqueceu sua senha?</a>}
            {modo === 'login' && <p>Ainda não tem uma conta? <a href="#/" onClick={() => setModo('register')}>Registre-se</a> </p>}
            {modo === 'register' && <p>Já possui uma conta? <a href="#/" onClick={() => setModo('login')}>Efetue login</a> </p>}
            {modo === 'forgot' && <p><a href="#/" onClick={() => setModo('login')}>Voltar para login</a> </p>}
          </Grid>
        </Grid>

        <Snackbar open={errorMessage !== undefined} autoHideDuration={4000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error">
            {errorMessage}
          </Alert>
        </Snackbar>

        <Snackbar open={msgSenhaRedefinida !== undefined} autoHideDuration={4000} onClose={handleCloseSenhaRedefinida}>
          <Alert onClose={handleCloseSenhaRedefinida} severity="success">
            {msgSenhaRedefinida}
          </Alert>
        </Snackbar>

      </div>

      <Box mt={8}>
        <Copyright />
      </Box>

    </Container>

  </div>
}

